module.exports = __webpack_public_path__ + "img/title-3.541b2add.png";